import { render, staticRenderFns } from "./productFiltering.vue?vue&type=template&id=4b245984"
import script from "./productFiltering.vue?vue&type=script&lang=js"
export * from "./productFiltering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b245984')) {
      api.createRecord('4b245984', component.options)
    } else {
      api.reload('4b245984', component.options)
    }
    module.hot.accept("./productFiltering.vue?vue&type=template&id=4b245984", function () {
      api.rerender('4b245984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/productFiltering.vue"
export default component.exports